import { FunctionComponent, useEffect, useRef, useState } from 'react';

import styles from './DashboardLayout.module.scss';
import { DashboardHandlers } from './types';

export type DashboardLayoutProps = {
  expandMenu?: boolean;
  handlers: DashboardHandlers;
  pathname: string;
  showBoundaries?: boolean;
  navTop?: React.JSX.Element;
  navSubTop?: React.JSX.Element;
  navLeft: React.JSX.Element;
  content: React.JSX.Element;
  footer: React.JSX.Element;
  isIframe?: boolean;
  isEmbedded?: boolean;
};

type FC = FunctionComponent<DashboardLayoutProps>;

const DashboardLayout: FC = ({
  handlers,
  pathname,
  showBoundaries = false,
  navTop,
  navSubTop,
  navLeft,
  content,
  footer,
  isIframe = false,
  isEmbedded = false,
}: DashboardLayoutProps) => {
  const bgClass = showBoundaries ? 'visible' : 'hidden';
  const topRef = useRef<HTMLInputElement>(null);

  const [isMobile, setIsMobile] = useState(true);
  const [isMini, setIsMini] = useState(true);

  window.addEventListener('resize', () => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  });

  useEffect(() => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  const mouseOver = () => {
    if (isMobile) {
      setIsMini(true);
      handlers.onMouseEnter(false);
    } else {
      setIsMini(false);
      handlers.onMouseEnter(true);
    }
  };

  const mouseLeave = () => {
    setIsMini(true);
    handlers.onMouseEnter(false);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [pathname]);

  return (
    <main className={`dashboardLayoutContainer ${styles[getIframeClass()]} `}>
      <nav className={styles[bgClass]}>{navTop}</nav>
      <div className={[isMini ? styles.mainContainerMini : styles.mainContainerBig, styles.mainContainer].join(' ')}>
        <div
          className={styles.position}
          onMouseOver={mouseOver}
          onMouseLeave={mouseLeave}
          onFocus={mouseOver}
          onBlur={mouseLeave}
        >
          <div className={[isMini ? styles.navLeftMini : styles.navLeftBig, styles.navLeft, styles[bgClass]].join(' ')}>
            {navLeft}
          </div>
        </div>
        <div
          id="contentContainer"
          className={[isMini ? styles.contentContainerMini : styles.contentContainerBig, styles.contentContainer].join(
            ' ',
          )}
        >
          <div className={styles.navSubTop}>{navSubTop}</div>
          <div className={[styles.content, styles[bgClass]].join(' ')}>
            <div ref={topRef} />
            <div className={`${styles.mainContent} ${isEmbedded ? styles.embedded : ''}`}>{content}</div>
            <div>{footer}</div>
          </div>
        </div>
      </div>
    </main>
  );

  function getIframeClass() {
    return isIframe ? 'iframe' : '';
  }
};

export default DashboardLayout;
